import { createSelector } from '@ngrx/store';

export const getOrganizationsState = createSelector(
    (state: any) => state.organizations,
    (state: any) => state.get('list')
);

export const getCreateOrganizationState = createSelector(
    (state: any) => state.organizations,
    (state: any) => state.get('createOrganization')
);

export const getUpdateOrganizationState = createSelector(
    (state: any) => state.organizations,
    (state: any) => state.get('updateOrganization')
);
 